import React from 'react';

const TimelineList = ({ list }) => (
  <div className='detail-timeline'>
    {list.map((item, index) => {
      return (
        <div
          key={index}
          className='detail-timeline__item'
          title={item.description}
        >
          {item.description}
        </div>
      )
    })}
  </div>
)

export default TimelineList;
